import { ApiProperty } from "@nestjs/swagger";

export class WhatsappLogsDto{
//    @ApiProperty()
//     logId:number
    @ApiProperty()
    contactNo:string

    @ApiProperty()
    templateName:string

    // @ApiProperty()
    // createdUser:string

    @ApiProperty()
    projectName:string

//    @ApiProperty()    
//     generetedAt:Date

    @ApiProperty()
    companyId:number;

    @ApiProperty()   
    moduleId:number;
}